interface ProfileIconProps {
  width?: number;
}

export const ProfileIcon = ({ width }: ProfileIconProps) => (
  <svg
    width={width || 300}
    height={width || 300}
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H300V300H0V0ZM68.75 222.688C68.75 224.813 69.1063 226.906 69.7875 228.881C49.0623 207.862 37.4609 179.518 37.5 150C37.5 87.8688 87.8688 37.5 150 37.5C212.131 37.5 262.5 87.8688 262.5 150C262.54 179.565 250.902 207.949 230.119 228.975C231.096 226.305 231.452 223.447 231.158 220.619C230.864 217.79 229.929 215.067 228.423 212.654C226.918 210.242 224.882 208.206 222.47 206.699C220.058 205.193 217.334 204.257 214.506 203.962C166.019 198.944 134.281 198.463 85.5563 203.85C80.9267 204.372 76.6522 206.582 73.5512 210.059C70.4502 213.536 68.7407 218.029 68.75 222.688ZM25 150C25 217.325 78.2313 272.225 144.9 274.9C146.311 274.978 147.724 275.009 149.137 274.994L150 275C219.037 275 275 219.037 275 150C275 80.9625 219.037 25 150 25C80.9625 25 25 80.9625 25 150ZM150 175C163.261 175 175.979 169.732 185.355 160.355C194.732 150.979 200 138.261 200 125C200 111.739 194.732 99.0215 185.355 89.6447C175.979 80.2678 163.261 75 150 75C136.739 75 124.021 80.2678 114.645 89.6447C105.268 99.0215 100 111.739 100 125C100 138.261 105.268 150.979 114.645 160.355C124.021 169.732 136.739 175 150 175Z"
      fill="#E6E8FF"
    />
  </svg>
)
